import { render, staticRenderFns } from "./VoucherCodes.vue?vue&type=template&id=f38f8c98&"
import script from "./VoucherCodes.vue?vue&type=script&lang=js&"
export * from "./VoucherCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports